import { Icon24ChevronCompactRight } from "@vkontakte/icons";
import s from "./style.module.scss";
import { CloseButton } from "@/components/CloseButton/CloseButton";
import { orderDocumentsAtom } from "@/core/reatom/state/orders/orders";
import { useAtom } from "@reatom/npm-react";
import { openLink } from "@telegram-apps/sdk-react";
interface DocumentsModalProps {
  closeModal: () => void;
}
export const DocumentsModal = (props: DocumentsModalProps) => {
  const { closeModal } = props;
  const [documents] = useAtom(orderDocumentsAtom);
  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <p className={s.title}>Документы сделки</p>
      <div className={s.documentWrapper}>
        {documents?.items.map((item, index) => (
          <DocumentLine
            key={index}
            title={item.file.source_name}
            redirect={item.file.url}
          />
        ))}
      </div>
    </div>
  );
};

interface DocumentLineProps {
  title: string;
  redirect: string;
}

export const DocumentLine = (props: DocumentLineProps) => {
  const { title, redirect } = props;
  return (
    <div className={s.documentLine} onClick={() => openLink(redirect)}>
      <div className={s.innerWrapper}>
        <p className={s.lineTitle}>{title}</p>
      </div>
      <Icon24ChevronCompactRight color="#B8C1CC" />
    </div>
  );
};
